<div
  class="position-absolute d-flex w-100 h-100 justify-content-center align-items-center"
  *ngIf="tendersSearchService.inSearch && !tendersSearchService.offset"
>
  <div class="position-absolute d-flex w-100 h-100 justify-content-center align-items-center">
    <ex-overlay-loader class="w-100 h-100" [text]="'tenders.loader.' + tendersSearchService.viewMode | translate" />
  </div>
</div>

<div class="table-container d-flex flex-column">
  <!-- NO RESULTS/FILTERS -->
  <div *ngIf="!tendersSearchService.tenders?.length" class="no-select no-result-container">
    <ng-container *ngTemplateOutlet="errorDisplay; context: { error: getFirstPreSearchError() }" />

    <!-- NO RESULTS -->
    <ng-container *ngIf="tendersSearchService.tenders && !tendersSearchService.inSearch && !getFirstPreSearchError()">
      <ng-container *ngTemplateOutlet="errorDisplay; context: { error: getFirstPostSearchError() }" />
    </ng-container>
  </div>
</div>

<cdk-virtual-scroll-viewport
  #tendersList
  *ngIf="tendersSearchService.tenders && tendersSearchService.tenders.length"
  [itemSize]="91"
  [minBufferPx]="200"
  infiniteScroll
  (endScroll)="loadMore()"
  class="tender-result-container"
  [ngClass]="{ 'has-scroll': hasScroll(), 'show-exclusions': showExcludedTenders }"
>
  <table class="result-table {{ showExcludedTenders ? 'show-exclusions' : '' }}" aria-label="tenders-list">
    <thead>
      <tr>
        <th class="align-middle">{{ 'tenders.table-column.number' | translate | uppercase }}</th>
        <th class="align-middle">{{ 'tenders.table-column.title' | translate | uppercase }}</th>
        <th class="align-middle">{{ 'tenders.table-column.tender-type' | translate | uppercase }}</th>
        <th class="date-header">{{ 'tenders.table-column.remaining-time' | translate | uppercase }}</th>
        <th class="status-header">{{ 'tenders.table-column.tender-status' | translate | uppercase }}</th>
      </tr>
    </thead>
    <tbody>
      <tr class="new-params" *ngIf="newParamsNotActiveYet && tendersModuleService.currentManager.marketWatch?.isOwnedByCurrentUser">
        <td class="new-params-td" colspan="5">
          <div class="d-flex align-items-center justify-content-center">
            <i class="ph ph-clock-clockwise"></i>
            <span
              >{{ 'tenders.market-watches.new-params-will-be-applied' | translate }}
              {{ 'alert.days.label.' + findNextWatchDay() | translate }}
              {{ 'tenders.market-watches.next' | translate }}
            </span>
          </div>
        </td>
      </tr>

      <ng-container *cdkVirtualFor="let tender of tenderList; let i = index; trackBy: identifyTender">
        <tr
          class="tender-row"
          data-cy="tender-row"
          [ngClass]="{ 'editor-is-open': tenderNoteEditorOpenings[tender.id] ?? false, 'excluded-tender': isExcludedTender(i) }"
          (mouseenter)="hoveredTenderId = tender.id"
          (mouseleave)="hoveredTenderId = null"
        >
          @if (i <= (tendersSearchService.tenders ?? []).length - 1) {
            <ng-container *ngTemplateOutlet="tenderTableRow; context: { tender: tender, index: i }" />
          } @else {
            <ng-container
              *ngTemplateOutlet="tenderTableRow; context: { tender: tender, index: i - (tendersSearchService.tenders ?? []).length }"
            />
          }
        </tr>
        @if (
          !watchManager?.editMode &&
          watchManager?.exclusionsService &&
          watchManager?.exclusionsService?.totalCount &&
          tendersSearchService.tenders?.length === tendersSearchService?.totalCount
        ) {
          @if (i + 1 === tendersSearchService.tenders?.length) {
            <tr #exclusionsButtonRow class="exclusions-button no-select" (click)="onClickExclusions()">
              <td colspan="5">
                <div class="d-flex w-100 align-items-center">
                  <div class="ps-2">
                    <mat-icon class="icon-24" svgIcon="sparks-filled" />
                  </div>
                  <div class="ms-3 d-flex align-items-center hovered-btn {{ showExcludedTenders ? 'open' : '' }}">
                    <div class="ps-3 fw-600">
                      {{ watchManager?.exclusionsService?.totalCount || 0 }}
                      @if (watchManager?.exclusionsService?.totalCount || 0 > 0) {
                        {{ 'tenders.exclusions.market-watches-excluded' | translate }}
                      } @else {
                        {{ 'tenders.exclusions.market-watch-excluded' | translate }}
                      }
                    </div>
                    <div class="ps-1 pe-2">
                      @if (showExcludedTenders) {
                        <i class="ph ph-caret-down"></i>
                      } @else {
                        <i class="ph ph-caret-right"></i>
                      }
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          }
        }
      </ng-container>
    </tbody>
  </table>
  <ng-container
    *ngTemplateOutlet="
      tableFooterRow;
      context: {
        service: tendersSearchService,
        hideCondition: !inWatches && tendersSearchService?.lastPageReached,
      }
    "
  ></ng-container>
</cdk-virtual-scroll-viewport>

<ng-template #tableFooterRow let-service="service" let-hideCondition="hideCondition">
  <div
    class="table-footer no-select {{ showExcludedTenders ? 'show-exclusions' : '' }}"
    [hidden]="hideCondition"
    [ngClass]="{ 'processed-watch': hasScroll() && service?.lastPageReached && !service.error }"
  >
    <div class="bg-basic-200 w-100">
      <app-simple-loader [size]="42" [isShown]="loadingMore" />
    </div>
    <div [hidden]="loadingMore || service.inSearch" class="footer-actions">
      <div
        [hidden]="service.lastPageReached || !service.error"
        (click)="service.error ? search() : loadMore()"
        (keydown)="service.error ? search() : loadMore()"
        class="footer-action"
      >
        <mat-icon [hidden]="!service.error" svgIcon="refresh" />
        <span>{{ (service.error ? 'tenders.table-footer.load-error' : 'tenders.table-footer.load-more') | translate }}</span>
      </div>
      <div
        [hidden]="
          !hasScroll() ||
          !service.lastPageReached ||
          service.error ||
          !inWatches ||
          inBoardView ||
          (showExcludedTenders && !watchManager?.exclusionsService?.lastPageReached)
        "
        (click)="scrollToTop()"
        (keydown)="scrollToTop()"
        class="footer-action"
      >
        <ex-empty-state
          [title]="'tenders.table-footer.processed-watch.message' | translate"
          [svgIcon]="'claping-hands'"
          [paddingTop]="'unset'"
        >
          <div *exEmptyStateContent>
            <div class="">{{ 'tenders.table-footer.processed-watch.description' | translate }}</div>
            <div class="pdt-16px d-flex align-items-center justify-content-center color-primary-500 fw-bold">
              <div>{{ 'tenders.table-footer.return-to-top' | translate }}</div>
              <mat-icon class="color-primary-500" svgIcon="arrow-up-circle" />
            </div>
          </div>
        </ex-empty-state>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tenderTableRow let-tender="tender" let-i="index">
  <!-- Colonne # NUMÉROS -->
  <td class="td-number">
    <div *ngIf="hoveredTenderId !== tender.id && !tendersExportService?.selection" class="number">{{ i + 1 }}</div>
    <div *ngIf="hoveredTenderId === tender.id || tendersExportService?.selection" class="ex-checkbox">
      <input type="checkbox" [checked]="tendersExportService?.selection?.includes(tender)" />
      <span class="checkmark" data-cy="tender-row-checkbox" (click)="tendersExportService?.select(tender)"></span>
    </div>
    <div *ngIf="!inWatches" class="in-watch-occurrence">
      <!--Si on n'a pas encore vérifié l'apparition et que la ligne est survolée -->
      <in-watch-occurrence *ngIf="tender.watchAppearance === undefined && hoveredTenderId === tender.id" [tender]="tender" />
      <!--Si on a déjà vérifié l'apparition et que la ligne est survolée -->
      <in-watch-occurrence *ngIf="tender.watchAppearance !== undefined" [tender]="tender" [hidden]="hoveredTenderId !== tender.id" />
    </div>
  </td>

  <!-- Colonne OBJET -->
  <td>
    <div
      class="td-title"
      [ngbTooltip]="getSanitizedString(tender.title)"
      placement="bottom auto"
      overflowTooltip
      [overflowThreshold]="4"
      #overflowTooltip="overflowTooltip"
      tooltipClass="tender-title-tooltip"
      [openDelay]="500"
    >
      <a
        data-cy="tender-row-title"
        [innerHTML]="tender.title"
        [routerLink]="tender.id"
        [queryParams]="{ from: 'search' }"
        (click)="trackClickedTender(tender)"
        aria-label="link-to-tender-detail"
      >
      </a>
      <!--PRODUCTION DE NOMBREUX BUGS DANS LA CONSOLE-->
      <span class="copy-link" [ngClass]="{ outside: overflowTooltip.overflowed, hovered: hoveredTenderId === tender.id }">
        <app-tender-link-copy-button *ngIf="hoveredTenderId === tender.id" [tender]="tender" class="copy-link" />
      </span>
    </div>
    <div class="info-container">
      <div class="inquirers-territories-assignees-suggestion-container d-flex flex-column">
        <div class="inquirers-and-territories-container">
          <i class="ph-fill ph-users"></i>
          <app-searchable-entity
            [styleClass]="'darkblue'"
            class="inquirers-container"
            [attributeName]="'organisation'"
            [baseUrl]="environment.appBaseUrl + '/tenders/search'"
            [entityName]="(tender.inquirers ?? []).join(', ') | removeDepartmentNumbers"
          />
          <app-inline-territories-display [territories]="tender.territories" [styleClass]="'strong'" />
        </div>

        @if (tender?.tenderType === TenderTypesEnum.ATTRIBUTION || tender?.tenderType === TenderTypesEnum.RECTIFICATIF) {
          @if (tender?.assignees && tender.assignees.length) {
            <app-tender-assignees
              [tender]="tender"
              [assigneePopOverId]="assigneePopOverId"
              (toggleAssigneePopover)="toggleOverlay($event)"
              (closeAssigneePopover)="closeOverlay()"
            />
          }
        }

        <!--Relevance is displayed only is tender is included, not excluded.-->
        <div *ngIf="tender.isSuggestion" class="d-flex align-items-start w-100">
          <relevance-indicator />
        </div>
      </div>

      <div class="tender-type-container">
        <div class="d-flex no-select">
          <i class="ph-fill ph-suitcase pdt-2px"></i>
          <div class="market-types-container">
            <ng-container *ngFor="let type of tender.marketType ?? []; let index = index">
              <div class="market-type ls-m1">{{ (type.toLowerCase() | articleTitleCase) ?? '' }}</div>
            </ng-container>
            <span *ngIf="!(tender.marketType ?? []).length" class="color-basic-600 fst-italic pdl-4px">{{
              'tenders.not-detected-m' | translate
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </td>

  <!-- Tender Type Column -->
  <td class="d-flex flex-column">
    <div class="d-flex">
      <app-tender-type-badge
        *ngIf="tender.tenderType !== 'undetermined'"
        [tenderType]="tender.tenderType"
        [style]="tender.tenderType === TenderTypesEnum.ATTRIBUTION ? 'dark' : 'light'"
      />
      <ex-badge
        *ngIf="tender.dceProjectUid"
        backgroundColor="var(--basic-250)"
        color="var(--basic-600)"
        borderColor="10%"
        text="DCE"
        class="dce-badge"
      />
    </div>

    <!--Date de parution-->
    <div class="d-flex text-truncate pdt-7px">
      <span class="day-text fw-600">{{
        'tenders.filter.indexed-on' | translate: { pronoun: isToday(tender.indexationDate) ? '' : 'le ' }
      }}</span>
      <span class="day-text fw-700 pdl-2px" *ngIf="isToday(tender.indexationDate) && !inWatches">{{
        'tenders.today' | translate | lowercase
      }}</span>
      <span
        class="day-text fw-700 pdl-2px"
        *ngIf="!isToday(tender.indexationDate) || inWatches"
        [ngbTooltip]="tender.indexationDate.toLocaleDateString()"
        overflowTooltip
        [openDelay]="500"
        tooltipClass="simple-tooltip"
        placement="bottom auto"
        container="body"
      >
        {{ tender.indexationDate.toLocaleDateString() }}</span
      >
    </div>

    <!--Montant du marché-->
    <div
      class="amount-compact d-flex align-items-center gap-2"
      [ngbTooltip]="tender.tenderType === TenderTypesEnum.ATTRIBUTION ? tenderAmountTooltip : null"
      [disableTooltip]="!tender.amount && !tender.assignees?.length"
      tooltipClass="custom-tooltip-attribution"
      placement="bottom auto"
      container="body"
      [openDelay]="300"
    >
      <ng-container *ngIf="tender.amount">
        <i class="ph-fill ph-coins color-basic-500"></i>
        <app-tender-amount compactVersion [amount]="tender.amount" />
      </ng-container>
    </div>

    <!--Tooltip affichant montants.-->
    <ng-template #tenderAmountTooltip>
      <div class="ph-text-align-left d-flex w-100">
        <span class="fw-600">{{ 'tenders.amount' | translate }}</span>
        <app-tender-amount class="pdl-4px" [amount]="tender.amount" />
      </div>
    </ng-template>
  </td>

  <!-- Remaining Time Column -->
  <td>
    <div class="d-flex flex-column">
      <div class="d-flex">
        <app-remaining-days-badge
          *ngIf="tender.daysLeft !== undefined"
          [days]="tender.daysLeft"
          color="gray"
          [ngbTooltip]="
            ('tenders.metadata.to' | translate) +
            (hasNonZeroTime(tender.closingDate)
              ? (tender.closingDate | date: 'dd/MM/yyyy à HH:mm')
              : (tender.closingDate | date: 'dd/MM/yyyy'))
          "
          [disableTooltip]="!tender.closingDate"
          placement="bottom auto"
          container="body"
          tooltipClass="tender-remaining-days-tooltip"
        />
      </div>
      <div *ngIf="tender.estimatedEndDate" class="d-flex text-truncate pdt-7px">
        <span
          class="day-text fw-600"
          [ngbTooltip]="'tenders.filter.will-end-on' | translate"
          overflowTooltip
          [openDelay]="500"
          tooltipClass="simple-tooltip"
          placement="bottom auto"
          container="body"
        >
          {{ 'tenders.filter.will-end-on' | translate }}&nbsp;</span
        >
        <span
          class="day-text fw-700"
          [ngbTooltip]="tender.estimatedEndDate.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })"
          overflowTooltip
          [openDelay]="500"
          tooltipClass="simple-tooltip"
          placement="bottom auto"
          container="body"
        >
          {{ tender.estimatedEndDate.toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' }) }}</span
        >
      </div>
    </div>
    <span *ngIf="tender.daysLeft === undefined" class="color-basic-600 fst-italic">
      {{ 'tenders.not-detected-m' | translate }}
    </span>
  </td>

  <!-- colonne de status -->
  <td class="column-status">
    <div class="d-flex flex-column">
      <div class="d-flex pdb-8px gap-2">
        <app-tender-status-selector
          [ngClass]="{ 'has-no-tender-status': !tender.status?.id }"
          [tender]="tender"
          [tenderStatus]="{ id: tender.statusId }"
          [placement]="'left'"
          (statusChange)="statusChange(tender, $event)"
        >
        </app-tender-status-selector>
        <app-tender-assignment
          [tender]="tender"
          [assigneeId]="tender.assignedUserId"
          size="small"
          [hidden]="hoveredTenderId !== tender.id && !tender.assignedUserId"
          [preferredOverlayPosition]="OVERLAY_POSITIONS['BOTTOM_RIGHT']"
        />
      </div>

      <div class="d-flex">
        <ex-note-editor
          *ngIf="!tender.hide"
          [ngClass]="{ 'has-tender-note': tender.note }"
          [service]="apiTendersService.annotation"
          [dbNote]="tender.note ?? ''"
          [tender]="tender"
          (noteChange)="noteChange(tender, $event)"
          (isEditorOpen)="isEditorOpened($event)"
          [style.visibility]="tender.note ? 'visible' : 'collapse'"
          [displayText]="!!tender.note"
        >
        </ex-note-editor>

        <!--empty to avoid vertical mouvement when note-editor rerendered-->
        <div class="empty-div" [style.height.px]="24" *ngIf="tender.hide"></div>

        <app-tender-share *ngIf="!tender.hide" [tender]="tender" displayShareIcon [smartGridService]="smartGridService"> </app-tender-share>
      </div>
    </div>
  </td>
</ng-template>

<ng-template #errorDisplay let-error="error">
  <ex-empty-state
    *ngIf="error"
    data-cy="tenders-empty-state"
    [svgIcon]="getIcon(error)"
    [title]="'tenders.error-display.' + error + '.message' | translate"
  >
    <div *exEmptyStateContent class="error-text">
      <!--Cas Erreur avec des liens || actions click -->
      <div *ngIf="error === 'first-day-watch-not-ready'">
        <span class="text">{{ 'tenders.error-display.' + error + '.description.text.' + 0 | translate }}</span>
        <span class="action-link" (click)="addMarketWatchUsers()" (keydown)="addMarketWatchUsers()">{{
          'tenders.error-display.' + error + '.description.link-label.' + 0 | translate
        }}</span>
        <span class="text">{{ 'tenders.error-display.' + error + '.description.text.' + 1 | translate }}</span>
        <span class="action-link" [routerLink]="['/tenders/search']">{{
          'tenders.error-display.' + error + '.description.link-label.' + 1 | translate
        }}</span
        >.
      </div>

      <div *ngIf="error === 'today-watch-not-ready'">
        <span class="text">{{ 'tenders.error-display.' + error + '.description.text' | translate }}</span>
        <span class="action-link" [routerLink]="['/tenders/search']">
          {{ 'tenders.error-display.' + error + '.description.link-label' | translate }}</span
        >
      </div>

      @if (error === 'no-text-or-topic') {
        <div class="d-flex flex-column gap-2">
          @for (item of ['text-or-topic', 'period', 'organisation']; track item) {
            <div class="d-flex gap-2">
              <mat-icon class="color-basic-500" svgIcon="{{ item }}-filter" />
              <span class="text">{{ 'tenders.error-display.no-text-or-topic.' + item | translate }}</span>
            </div>
          }
        </div>
      }

      <!--Cas Erreur avec que du text -->
      <span *ngIf="error !== 'first-day-watch-not-ready' && error !== 'today-watch-not-ready' && error !== 'no-text-or-topic'">
        {{ 'tenders.error-display.' + error + '.description' | translate }}</span
      >
    </div>
  </ex-empty-state>
</ng-template>
